import React from 'react';
import Links from '../Tools/links';

const Info = props => {

  return (
    <div className="orch_links">
      {props.contest && (
        <div>
          <h3>Contest Schedule</h3>
          <Links input={props.contest} />
        </div>
      )}
      <div>
        <h3>{props.title}</h3>
        <Links input={props.files}/>
      </div>
    </div>
  );
};

export default Info;



// WEBPACK FOOTER //
// ./src/Components/Tools/Info.js